import React from 'react';
import {TouchableOpacity, StyleSheet} from 'react-native';
import flexCheck from '../../../../utils/flexCheck';
const TouchableOpacitys = React.forwardRef((props, ref) => {
  const styles = StyleSheet.flatten(props.style);
  let updatedStyles = false;
  if (typeof props !== 'undefined' && typeof styles !== 'undefined') {
    updatedStyles = flexCheck(styles);
  }
  return (
    <>
      <TouchableOpacity
        ref={ref}
        {...props}
        style={updatedStyles ? updatedStyles : styles}
      />
    </>
  );
});
export default TouchableOpacitys;
